let audioCtx = null;

export const unlockAudio = () => {
  try {
    if (!audioCtx) {
      audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    }
    if (audioCtx.state === 'suspended') {
      void audioCtx.resume();
    }
  } catch (_) { /* ignore */ }
};

if (typeof document !== 'undefined') {
  const once = () => {
    unlockAudio();
    document.removeEventListener('touchstart', once);
    document.removeEventListener('click', once);
  };
  document.addEventListener('touchstart', once, { passive: true });
  document.addEventListener('click', once);
}

export const playOrderAlert = () => {
  try {
    unlockAudio();
    if (!audioCtx) return;
    const beep = (freq, start, duration, volume = 0.4) => {
      const o = audioCtx.createOscillator();
      const g = audioCtx.createGain();
      o.connect(g);
      g.connect(audioCtx.destination);
      o.frequency.value = freq;
      o.type = 'sine';
      g.gain.setValueAtTime(0, audioCtx.currentTime + start);
      g.gain.linearRampToValueAtTime(volume, audioCtx.currentTime + start + 0.02);
      g.gain.linearRampToValueAtTime(0, audioCtx.currentTime + start + duration);
      o.start(audioCtx.currentTime + start);
      o.stop(audioCtx.currentTime + start + duration + 0.05);
    };
    beep(660, 0, 0.14, 0.45);
    beep(880, 0.16, 0.2, 0.5);
  } catch (_) { /* autoplay blocked */ }
};

/** Foreground push — system notification often plays the default tone on Android. */
export const notifyOrderUpdate = (title, body) => {
  playOrderAlert();
  if (typeof Notification === 'undefined' || Notification.permission !== 'granted') return;
  try {
    const n = new Notification(title || 'MyTownly', {
      body: body || '',
      silent: false,
      tag: 'mytownly-order-update',
      renotify: true,
    });
    setTimeout(() => n.close(), 8000);
  } catch (_) { /* ignore */ }
};
